import { render, staticRenderFns } from "./VCadastrar.vue?vue&type=template&id=5643502a&scoped=true&"
import script from "./VCadastrar.vue?vue&type=script&lang=js&"
export * from "./VCadastrar.vue?vue&type=script&lang=js&"
import style0 from "./VCadastrar.vue?vue&type=style&index=0&id=5643502a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5643502a",
  null
  
)

export default component.exports